import { __assign } from "tslib";
import { OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@angular/common";
var MicrofrontendNavigationService = /** @class */ (function () {
    function MicrofrontendNavigationService(router, location, activatedRoute) {
        var _this = this;
        this.router = router;
        this.location = location;
        this.activatedRoute = activatedRoute;
        this.routerSubscription = null;
        this.handleMicrofrontendNavigate = function (event) {
            var payload = event.detail;
            switch (payload.event) {
                case 'push':
                    if (payload.path) {
                        // Construct query params if provided
                        var queryParams = payload.query || {};
                        // Navigate to the specified path with query params
                        _this.router.navigate([payload.path], {
                            queryParams: queryParams,
                            queryParamsHandling: 'merge'
                        });
                    }
                    break;
                case 'replace':
                    if (payload.path) {
                        // Construct query params if provided
                        var queryParams = payload.query || {};
                        // Navigate to the specified path with query params using replaceUrl
                        _this.router.navigate([payload.path], {
                            queryParams: queryParams,
                            queryParamsHandling: 'merge',
                            replaceUrl: true
                        });
                    }
                    break;
                case 'back':
                    _this.location.back();
                    break;
            }
        };
        this.setupEventListener();
        this.subscribeToRouteChanges();
    }
    MicrofrontendNavigationService.prototype.setupEventListener = function () {
        window.addEventListener('microfrontendNavigate', this.handleMicrofrontendNavigate);
    };
    MicrofrontendNavigationService.prototype.subscribeToRouteChanges = function () {
        var _this = this;
        this.routerSubscription = this.router.events
            .pipe(filter(function (event) { return event instanceof NavigationEnd; }))
            .subscribe(function () {
            // Get all route params (including nested routes)
            var params = _this.getAllRouteParams(_this.activatedRoute);
            // Dispatch custom event to microfrontend
            var customEvent = new CustomEvent('microfrontendRouteChange', {
                detail: { params: params }
            });
            window.dispatchEvent(customEvent);
        });
    };
    MicrofrontendNavigationService.prototype.getAllRouteParams = function (route) {
        var params = {};
        // Traverse the route tree to collect all params
        var currentRoute = route;
        while (currentRoute) {
            if (currentRoute.snapshot.params) {
                params = __assign(__assign({}, params), currentRoute.snapshot.params);
            }
            if (currentRoute.snapshot.queryParams) {
                params = __assign(__assign({}, params), currentRoute.snapshot.queryParams);
            }
            currentRoute = currentRoute.firstChild;
        }
        return params;
    };
    MicrofrontendNavigationService.prototype.ngOnDestroy = function () {
        // Clean up event listener
        window.removeEventListener('microfrontendNavigate', this.handleMicrofrontendNavigate);
        // Clean up router subscription
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    };
    MicrofrontendNavigationService.ngInjectableDef = i0.defineInjectable({ factory: function MicrofrontendNavigationService_Factory() { return new MicrofrontendNavigationService(i0.inject(i1.Router), i0.inject(i2.Location), i0.inject(i1.ActivatedRoute)); }, token: MicrofrontendNavigationService, providedIn: "root" });
    return MicrofrontendNavigationService;
}());
export { MicrofrontendNavigationService };
